import React from 'react';

export default function CurrentTransactionIcon() {
  return (
    <svg
      width="12"
      height="16"
      viewBox="0 0 12 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect width="12" height="16" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.82731e-06 0.533336C-0.00142481 0.271678 0.22249 0.0272794 0.488642 1.47336e-06H8C8.14292 -0.000334818 8.28511 0.0569132 8.38636 0.155558L11.8409 3.53333C11.9418 3.63233 12.0003 3.77136 12 3.91111V15.4667C12 15.7459 11.7401 16 11.4545 16H0.545461C0.259867 16 3.19182e-05 15.7459 6.82731e-06 15.4667V0.533336ZM7.26518 1.56274L1.49999 1.56684V14.4333H10.5V4.4282H8.10904C7.56064 4.4282 7.26521 3.68625 7.26518 3.40701V1.56274ZM10.142 3.37778L8.54545 1.81667V3.37778H10.142ZM3.56771 12.4991C3.28549 12.5196 3.01533 12.1811 3.00063 11.7886C2.98593 11.3962 3.22934 11.0205 3.51156 11.0001H8.4538C8.7384 10.9948 9 11.3538 9 11.7496C9 12.1454 8.7384 12.5044 8.4538 12.4991H3.56771ZM3.00063 8.78863C3.01533 9.18108 3.28549 9.51956 3.56771 9.49912H8.4538C8.7384 9.50437 9 9.1454 9 8.7496C9 8.35378 8.7384 7.99481 8.4538 8.00006H3.51156C3.22934 8.02055 2.98593 8.39618 3.00063 8.78863ZM3.56771 6.49912C3.28549 6.51956 3.01533 6.18108 3.00063 5.78863C2.98593 5.39618 3.22934 5.02055 3.51156 5.00006H8.4538C8.7384 4.99481 9 5.35378 9 5.7496C9 6.1454 8.7384 6.50437 8.4538 6.49912H3.56771Z"
        fill="#445261"
      />
    </svg>
  );
}
